export const baseUrl = process.env.REACT_APP_API_BASE as string;

export function effectivePromptName(
  promptName: string | undefined
): string | undefined {
  if (promptName == null) return promptName;
  const match = promptName.match(/promptKey\(([-.\w\d]+)\)/);
  return match != null ? match[1] : promptName;
}
